import { useState } from "react";
import { propertyPhotos as photos } from "@/mocks/propertyMedia";

export default function PhotoGallery() {
  const [current, setCurrent] = useState(0);
  const [lightbox, setLightbox] = useState(false);

  const prev = () => setCurrent((c) => (c === 0 ? photos.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === photos.length - 1 ? 0 : c + 1));

  return (
    <div className="relative w-full">
      {/* Main image */}
      <div className="relative w-full h-[560px] md:h-[760px] overflow-hidden bg-gray-100">
        <span className="absolute top-4 left-4 z-10 bg-amber-600 text-white text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide whitespace-nowrap">
          Na wyłączność
        </span>
        <img
          src={photos[current]}
          alt={`Zdjęcie nieruchomości ${current + 1}`}
          className="w-full h-full object-cover object-center cursor-pointer transition-opacity duration-300"
          onClick={() => setLightbox(true)}
        />
        <button
          onClick={prev}
          className="absolute left-3 md:left-5 top-1/2 -translate-y-1/2 w-9 h-9 md:w-11 md:h-11 flex items-center justify-center bg-white/80 hover:bg-white rounded-full cursor-pointer transition-colors"
          aria-label="Poprzednie zdjęcie"
        >
          <i className="ri-arrow-left-s-line text-gray-800 text-xl" />
        </button>
        <button
          onClick={next}
          className="absolute right-3 md:right-5 top-1/2 -translate-y-1/2 w-9 h-9 md:w-11 md:h-11 flex items-center justify-center bg-white/80 hover:bg-white rounded-full cursor-pointer transition-colors"
          aria-label="Następne zdjęcie"
        >
          <i className="ri-arrow-right-s-line text-gray-800 text-xl" />
        </button>
        <div className="absolute bottom-4 right-4 bg-black/50 text-white text-xs px-2.5 py-1 rounded-full whitespace-nowrap">
          {current + 1} / {photos.length}
        </div>
      </div>

      {/* Thumbnails */}
      <div className="flex gap-2 mt-2 overflow-x-auto pb-1 px-0">
        {photos.map((src, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`flex-shrink-0 w-16 h-12 md:w-20 md:h-14 overflow-hidden rounded-md cursor-pointer border-2 transition-all ${
              i === current ? "border-amber-600" : "border-transparent"
            }`}
          >
            <img
              src={src}
              alt={`Miniatura ${i + 1}`}
              className="w-full h-full object-cover object-center"
            />
          </button>
        ))}
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center"
          onClick={() => setLightbox(false)}
        >
          <button
            onClick={() => setLightbox(false)}
            className="absolute top-4 right-5 w-10 h-10 flex items-center justify-center text-white text-2xl cursor-pointer"
          >
            <i className="ri-close-line" />
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); prev(); }}
            className="absolute left-3 md:left-8 w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-white text-2xl" />
          </button>
          <img
            src={photos[current]}
            alt="Pełny widok"
            className="max-h-[90vh] max-w-[90vw] object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
          <button
            onClick={(e) => { e.stopPropagation(); next(); }}
            className="absolute right-3 md:right-8 w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-white text-2xl" />
          </button>
        </div>
      )}
    </div>
  );
}
